import { TableRow } from "@mui/material";
import React from "react";
import aderantTheme from "../../../Theme/AderantTheme";
import GridCell from "../GridCell";
import GroupHeaderCell from "../GroupHeaderCell";
import RowPrefix from "../RowPrefix";
const palette = aderantTheme.palette;
/**
 * A function that renders a row and its cells in the EditableGrid.
 */
export function EditableGridRow(props) {
    const { allowSelection, columns, getColumnWidth, getRowProps, isEditing, isRowLoading, isRowReadOnly, row, rowIndex } = props;
    let renderCells = [];
    let checkboxLabel = "";
    const rowRef = React.useRef(null);
    if (row.isGrouped) {
        checkboxLabel = `${row.id}-group`;
    }
    else {
        renderCells = row.cells.map((cell, index) => {
            if (index == 0) {
                checkboxLabel = cell.value && typeof cell.value === "string" ? cell.value : index.toString();
            }
            const columnStyle = isEditing ? cell.column.cellEditStyle : cell.column.cellStyle;
            return (React.createElement(GridCell, { cell: cell, columnWidth: getColumnWidth(cell.column.id), isRowLoading: isRowLoading, style: columnStyle, key: `row-${rowIndex}-cell-${index}` }, isEditing && cell.column.CellEdit ? cell.render("CellEdit") : cell.render("Cell")));
        });
    }
    return (React.createElement(TableRow, { component: "div", "data-testid": "editable-grid-row", tabIndex: 0, ...row.getRowProps(getRowProps(row)), key: `${rowIndex}-row`, 
        // This "!important" flag gives this style priority over other styles. This was done because this style was being
        // overwritten by the displayRowStyle. If we ever need to expose this color for the control
        // we would need to merge the styles within the RenderRow function in EditableGridTable.tsx
        sx: { "&:focus-within": { backgroundColor: `${palette.background.focus} !important` }, ...(isRowReadOnly && !row.isGrouped ? { "*": { pointerEvents: "none" } } : {}), ...props.sx } },
        React.createElement(RowPrefix, { allowSelection: allowSelection ?? false, row: row, checkboxLabel: checkboxLabel, isRowLoading: isRowLoading, isRowReadOnly: isRowReadOnly }),
        row.isGrouped ? React.createElement(GroupHeaderCell, { row: row, columns: columns, rowRef: rowRef, focusedRowId: undefined }) : renderCells));
}
